// document.addEventListener('DOMContentLoaded', function () {
//     const rotateBtn = document.querySelector('.product_rotate_btn_col');

//     rotateBtn.addEventListener('click', function () {
//       const sections = document.querySelectorAll('.rotate_wrap_img');
//       const current = document.querySelector('.rotate_wrap_img.active-img');

//       if (current) {
//         current.classList.remove('active-img');

//         // Find the index of the current element
//         let currentIndex = Array.from(sections).indexOf(current);

//         // Calculate next index (loop to start if at end)
//         let nextIndex = (currentIndex + 1) % sections.length;

//         // Add active class to the next element
//         sections[nextIndex].classList.add('active-img');
//       }
//     });
//   });

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-tabs-section').forEach(section => {
    const rotateBtn = section.querySelector('.product_rotate_btn_col');

    if (!rotateBtn) return;

    rotateBtn.addEventListener('click', function () {
      const items = section.querySelectorAll('.rotate_wrap_img');
      const current = section.querySelector('.rotate_wrap_img.active-img');

      let currentIndex = current ? Array.from(items).indexOf(current) : 0;

      // Remove active from current
      if (current) current.classList.remove('active-img');

      // Calculate next index
      let nextIndex = (currentIndex + 1) % items.length;

      // Add active to the next image
      items[nextIndex].classList.add('active-img');
    });
  });
});